import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-config-card',
  templateUrl: './broadcastings-config-card.component.html',
  styleUrls: ['./broadcastings-config-card.component.scss']
})
export class BroadcastingsConfigCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
